import React, { useState, useEffect, useRef } from "react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuCheckboxItem,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from "./dropdown-menu"; // Assuming you export your components from here
import { IoIosArrowDown } from "react-icons/io";
import { Label } from "./label";
import { Button } from "./button";

const AdvancedDropdownWithCheckbox = ({
  label = true,
  options,
  selectedOptions,
  setSelectedOptions,
  placeholder,
  id,
  name,
  select,
  disabled = false,
  required = false,
  selectedClassOptions,
  selectedSchemeOptions,
  combinationOfFolioNameSchemeClass=[],
  setCombinationOfFolioNameSchemeClass
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [isOpen, setIsOpen] = useState(false); // Track if the dropdown is open
  const dropdownRef = useRef(null);
  const [selectedOptionsFromDropdown, setSelectedOptionsFromDropdown] = useState([]);

  const handleSelectOption = (option) => {
    if (select === "single") {
      setSelectedOptions([option]); // Set the selected option directly for single selection
      setSelectedOptionsFromDropdown([option]);
    } else {
      setSelectedOptionsFromDropdown((prevSelected) =>
        prevSelected.includes(option)
          ? prevSelected.filter((item) => item !== option) // Remove if already selected
          : [...prevSelected, option] // Add if not selected
      );
      setSelectedOptions((prevSelected) =>
        prevSelected.includes(option)
          ? prevSelected.filter((item) => item !== option)
          : [...prevSelected, option]
      );

      // const newCombination = `${option}-${selectedSchemeOptions}-${selectedClassOptions}`;
    

      // setCombinationOfFolioNameSchemeClass((prev) => {
      //   const combinationIndex = prev.indexOf(newCombination);
      //   if (combinationIndex > -1) {
      //     // Remove the combination if it exists
      //     return prev.filter((item) => item !== newCombination);
      //   } else {
      //     // Add the combination if it doesn't exist
      //     return [...prev, newCombination];
      //   }
      // });

    }
  };

  const handleRemoveOption = (option) => {
    if (select === "multiple") {
      setSelectedOptions((prev) => prev.filter((item) => item !== option));
      setSelectedOptionsFromDropdown((prev) => prev.filter((item) => item !== option));
    }
  };

  const handleReset = () => {
    setSelectedOptions([]); // Reset selection to an empty array
    setSelectedOptionsFromDropdown([]);
    // setCombinationOfFolioNameSchemeClass((prev) =>
    //   prev.filter(
    //     (item) =>
    //       !options.some(
    //         (option) =>
    //           item === `${option}-${selectedSchemeOptions}-${selectedClassOptions}`
    //       )
    //   )
    // );
  };

  const handleSelectAll = () => {
    if (selectedOptionsFromDropdown.length === options.length) {
      // If all options are already selected, deselect all
      handleReset();
  
       } else {
      // Otherwise, select all options
      setSelectedOptions([...options]);
      setSelectedOptionsFromDropdown([...options]);
    }
  };

  const filteredOptions = options.filter((option) =>
    option.toLowerCase().includes(searchValue.toLowerCase())
  );

  // Check if all options are selected
  const isAllSelected = selectedOptionsFromDropdown.length === options.length;

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false); // Close the dropdown if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex flex-col w-full gap-2">
      {label && (
        <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor={id}>
          {name} {required && <span className="text-red-600">*</span>}
        </Label>
      )}

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            id={id}
            variant="outline"
            size="lg"
            disabled={disabled}
            className={`h-10 gap-1 w-full text-md flex border-[#3a5dd1] rounded-md border justify-between items-center px-8 ${
              disabled ? "bg-gray-200 cursor-not-allowed" : ""
            }`}
            onClick={() => setIsOpen((prev) => !prev)} // Toggle dropdown open/close
          >
            <span className="sr-only sm:not-sr-only">
              {`Select ${name}`}
            </span>
            <IoIosArrowDown
              className={`ml-1 ${disabled ? "text-gray-400" : "text-[#0D215C]"}`}
            />
          </Button>
        </DropdownMenuTrigger>

        {isOpen && !disabled && (
          <DropdownMenuContent
            ref={dropdownRef} // Attach the ref to the dropdown content
            className="w-[var(--radix-dropdown-menu-trigger-width)] max-h-[300px] overflow-auto"
          >
            <DropdownMenuLabel>{placeholder} Options</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <div className="p-2">
              <input
                type="text"
                value={searchValue}
                onChange={(e) => {
                  e.stopPropagation();
                  setSearchValue(e.target.value);
                }}
                placeholder={`Search ${placeholder}`}
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <DropdownMenuSeparator />
            
            {/* "Select All" Checkbox */}
            <div className="flex items-center gap-2 px-2 py-1 cursor-pointer">
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={handleSelectAll}
                className="form-checkbox"
              />
              <span>{isAllSelected ? "Deselect All" : "Select All"}</span>
            </div>
            <DropdownMenuSeparator />
            
            {filteredOptions.map((option, index) => (
              <div key={index} className="flex flex-col">
                <label className="flex items-center gap-2 px-2 py-1 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={selectedOptionsFromDropdown.includes(option) && combinationOfFolioNameSchemeClass.includes(`${option}-${selectedSchemeOptions}-${selectedClassOptions}`)}
                    onChange={(e) => {
                      e.stopPropagation();
                      handleSelectOption(option);
                    }}
                    className="form-checkbox"
                  />
                  <span>{option}</span>
                </label>
                {index < filteredOptions.length - 1 && <hr className="my-1 border-gray-300" />}
              </div>
            ))}

            {/* Reset option */}
            <DropdownMenuSeparator />
            <DropdownMenuCheckboxItem
              onClick={(e) => {
                e.stopPropagation();
                handleReset();
              }}
              className="text-red-500 font-bold"
            >
              Reset Selection
            </DropdownMenuCheckboxItem>
          </DropdownMenuContent>
        )}
      </DropdownMenu>

      <div
        className={`w-full flex flex-wrap gap-4 ${disabled ? "pointer-events-none opacity-50" : ""}`}
        aria-disabled={disabled}
      >
        {/* Render selected options if necessary */}
      </div>
    </div>
  );
};

export default AdvancedDropdownWithCheckbox;
